// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/** Common **/
.PopularLocationItem-textEllipsis-FI5c0 {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.PopularLocationItem-imgContainer-fsZiq {
    position: relative;
    width: 100%;
}
.PopularLocationItem-infoContainer-l8Nzp {
    text-align: center;
    text-transform: capitalize;
    color: var(--common-text-color);
}
.PopularLocationItem-zoomContainer-ciTxx {
    position: relative;
    margin: 6px auto 0 auto;
    overflow: hidden;
    border-radius: 50%;
    width: 110px;
    height: 110px;
    transition: all 0.2s linear;
    -webkit-transition: all 0.2s linear;
}
.PopularLocationItem-outLineBorder-YPrRD {
    border: 1px solid var(--primary-border);
    padding: 30px 20px 20px;
    border-radius: 12px;
    position: relative;
}
.PopularLocationItem-outLineBorder-YPrRD:hover {
    background: #f4f6ff8a;
}
.PopularLocationItem-outLineBorder-YPrRD::before {
    content: "";
    width: 150px;
    height: 150px;
    position: absolute;
    background: var(--common-gray-bg-color);
    z-index: 1;
    -webkit-transition: all .5s ease;
    transition: all .5s ease;
    border-radius: 50%;
    top: 15px;
    left: 0;
    right: 0;
    margin: 0 auto;

}
.PopularLocationItem-imageContent-HSg3N {
    height: 100%;
    width: 100%;
    background-position: 50% 50%;
    background-repeat: no-repeat;
    background-size: cover;
    position: absolute;
    -webkit-backface-visibility: hidden;
            backface-visibility: hidden;
    z-index: 2;
}
.PopularLocationItem-noLine-F2cS9 {
    text-decoration: none !important;
}
/** Home slider Item - Start **/`, "",{"version":3,"sources":["webpack://./src/components/Home/PopularLocationItem/PopularLocationItem.css"],"names":[],"mappings":"AAAA,aAAa;AACb;IACI,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;AAEA;IACI,kBAAkB;IAClB,0BAA0B;IAC1B,+BAA+B;AACnC;AAEA;IACI,kBAAkB;IAClB,uBAAuB;IACvB,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,2BAA2B;IAC3B,mCAAmC;AACvC;AAEA;IACI,uCAAuC;IACvC,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;AACtB;AAEA;IACI,qBAAqB;AACzB;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,uCAAuC;IACvC,UAAU;IACV,gCAAwB;IAAxB,wBAAwB;IACxB,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,cAAc;;AAElB;AAEA;IACI,YAAY;IACZ,WAAW;IACX,4BAA4B;IAC5B,4BAA4B;IAC5B,sBAAsB;IACtB,kBAAkB;IAClB,mCAA2B;YAA3B,2BAA2B;IAC3B,UAAU;AACd;AAEA;IACI,gCAAgC;AACpC;AAEA,+BAA+B","sourcesContent":["/** Common **/\n.textEllipsis {\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.imgContainer {\n    position: relative;\n    width: 100%;\n}\n\n.infoContainer {\n    text-align: center;\n    text-transform: capitalize;\n    color: var(--common-text-color);\n}\n\n.zoomContainer {\n    position: relative;\n    margin: 6px auto 0 auto;\n    overflow: hidden;\n    border-radius: 50%;\n    width: 110px;\n    height: 110px;\n    transition: all 0.2s linear;\n    -webkit-transition: all 0.2s linear;\n}\n\n.outLineBorder {\n    border: 1px solid var(--primary-border);\n    padding: 30px 20px 20px;\n    border-radius: 12px;\n    position: relative;\n}\n\n.outLineBorder:hover {\n    background: #f4f6ff8a;\n}\n\n.outLineBorder::before {\n    content: \"\";\n    width: 150px;\n    height: 150px;\n    position: absolute;\n    background: var(--common-gray-bg-color);\n    z-index: 1;\n    transition: all .5s ease;\n    border-radius: 50%;\n    top: 15px;\n    left: 0;\n    right: 0;\n    margin: 0 auto;\n\n}\n\n.imageContent {\n    height: 100%;\n    width: 100%;\n    background-position: 50% 50%;\n    background-repeat: no-repeat;\n    background-size: cover;\n    position: absolute;\n    backface-visibility: hidden;\n    z-index: 2;\n}\n\n.noLine {\n    text-decoration: none !important;\n}\n\n/** Home slider Item - Start **/"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"textEllipsis": `PopularLocationItem-textEllipsis-FI5c0`,
	"imgContainer": `PopularLocationItem-imgContainer-fsZiq`,
	"infoContainer": `PopularLocationItem-infoContainer-l8Nzp`,
	"zoomContainer": `PopularLocationItem-zoomContainer-ciTxx`,
	"outLineBorder": `PopularLocationItem-outLineBorder-YPrRD`,
	"imageContent": `PopularLocationItem-imageContent-HSg3N`,
	"noLine": `PopularLocationItem-noLine-F2cS9`
};
module.exports = ___CSS_LOADER_EXPORT___;
